<template>
  <div class="adv-listing-filters-clear">
    <a :href="getUrlNoFilters" class="adv-listing-filters-clear-btn">{{ t('filters.clear.all') }}</a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdvListingUsedFiltersClear',
  computed: {
    ...mapGetters([
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getUrlNoFilters',
      'config'
    ])
  }
}
</script>

<style lang="scss" scoped>
.adv-listing-filters-clear {
  position: relative;
  display: flex;
  align-items: center;
  width: fit-content;
  height: 100%;
  border-left: 1px solid #040404;
  &-btn {
    display: block;
    width: 100%;
    text-align: center;
    font-size: 14px;
    line-height: 1.2;
    color: black;
    white-space: nowrap;
    padding-left: 15px;
    padding-right: 15px;
    font-weight: 700;
  }
}
</style>
